import { createFileRoute, notFound } from "@tanstack/react-router";
import { MarketingIntegrationPage } from "../components/marketing/MarketingIntegrationPage";
import { contentHead } from "../marketing-content/head";
import { findIntegration, integrationPage } from "../marketing-content/integrations";

export const Route = createFileRoute("/integrations_/$slug")({
  loader: ({ params }) => {
    const integration = findIntegration(params.slug);
    if (!integration) throw notFound();
    return integration;
  },
  head: ({ loaderData }) => contentHead(loaderData && integrationPage(loaderData)),
  component: IntegrationRoute,
});

function IntegrationRoute() {
  const integration = Route.useLoaderData();
  return <MarketingIntegrationPage integration={integration} key={integration.slug} />;
}
